/* eslint max-len: 0 */
import React, { SVGProps } from 'react';

export const RightArrowCircleOutline = ( props: SVGProps<SVGSVGElement> ) => (
	<svg
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{ ...props }
	>
		<path d='M13.4685 8.41435C13.1451 8.15559 12.6731 8.20803 12.4143 8.53148C12.1556 8.85492 12.208 9.32689 12.5315 9.58565L13.8619 10.65H11C8.92893 10.65 7.25 12.3289 7.25 14.4V15C7.25 15.4142 7.58579 15.75 8 15.75C8.41421 15.75 8.75 15.4142 8.75 15V14.4C8.75 13.1574 9.75736 12.15 11 12.15H13.8619L12.5315 13.2143C12.208 13.4731 12.1556 13.9451 12.4143 14.2685C12.6731 14.592 13.1451 14.6444 13.4685 14.3856L16.4685 11.9856C16.6464 11.8433 16.75 11.6278 16.75 11.4C16.75 11.1722 16.6464 10.9567 16.4685 10.8143L13.4685 8.41435Z' />
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25ZM3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.25 16.5563 16.5563 20.25 12 20.25C7.44365 20.25 3.75 16.5563 3.75 12Z'
		/>
	</svg>
);
